import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { onboardingApi, tutoriaisApi } from '../../api/endpoints'

/** Estado do onboarding e passos derivados dos dados. Sempre revalida ao montar: os passos se concluem pelo uso. */
export function useOnboarding() {
  return useQuery({ queryKey: ['onboarding'], queryFn: onboardingApi.obter, staleTime: 0 })
}

export function useAtualizarOnboarding() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: onboardingApi.atualizar,
    onSuccess: (info) => { if (info) qc.setQueryData(['onboarding'], info) },
  })
}

/** Liberação de cada recurso no plano (aba Tutoriais). */
export function useTutoriaisPlanos() {
  return useQuery({ queryKey: ['tutoriais-planos'], queryFn: tutoriaisApi.planos, staleTime: 60_000 })
}
